import ModalVerPdf from '../components/ModalVerPdf.vue';

export default {
  components: {
    ModalVerPdf,
  },
  data() {
    return {
      previsualizacion: null,
      esImagen: false,
      esPDF: false,
    };
  },
  methods: {
    onFileChange() {
      if (this.archivo) {
        const reader = new FileReader();
        const fileType = this.archivo.type;

        reader.onload = (e) => {
          const result = e.target.result;

          if (fileType.includes('image')) {
            this.previsualizacion = result;
            this.esImagen = true;
            this.esPDF = false;
          } else if (fileType.includes('pdf')) {
            const blob = new Blob([this.archivo], { type: fileType });
            const url = URL.createObjectURL(blob);

            this.previsualizacion = url;
            this.esImagen = false;
            this.esPDF = true;
          } else {
            this.previsualizacion = null;
            this.esImagen = false;
            this.esPDF = false;
          }
        };

        reader.readAsDataURL(this.archivo);
      } else {
        this.previsualizacion = null;
        this.esImagen = false;
        this.esPDF = false;
      }
    },
    verPrevisualizacionArchivo() {
      this.$refs.modalVerPdfRef.abrir(this.previsualizacion);
    },
  },
};
